import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnBuildingCompany = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M2.835 21h18.33m-2.75 0v-4.281m0 0c-1.016 0-1.833-.944-1.833-2.118v-2.186c0-1.174.817-2.118 1.833-2.118s1.833.944 1.833 2.118v2.186c0 1.174-.816 2.118-1.833 2.118m-14.32 4.037V5.824c0-1.88.81-2.824 2.419-2.824h5.037c1.609 0 2.41.944 2.41 2.824v14.932M7.054 7.932h3.946m-3.946 3.946h3.946m-1.973 5.918v2.96"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnBuildingCompany;
